import { EmployeeImporterFieldsDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import useGetDateFormat from 'modules/employees/hooks/useGetDateFormat'

export const useEmployeeImporterFields = () => {
  const { data, loading } = useQuery(EmployeeImporterFieldsDocument)
  const { dateFormat } = useGetDateFormat()

  const processedFields = data?.dataDispatcher.dataSchemasConnection.nodes.map((field) => ({
    ...field,
    label: field.fieldType === 'date' ? `${field.label}: ${dateFormat}` : field.label,
  }))

  return {
    loading,
    fields: processedFields?.sort((a, b) => {
      if (a.required !== b.required) {
        return a.required ? -1 : 1
      }
      return (a.position || 0) - (b.position || 0)
    }),
  }
}
